import Vue from 'vue';
import Vuetify from 'vuetify';
/*
import Vuetify, {
  VBanner,
  VApp,
  VAppBar,
  VTooltip,
  VBtn,
  VIcon,
  VImg,
  VContainer,
  VRow,
  VCol,
  VSystemBar,
  VHover,
  VLayout,
  VParallax,
  VDivider,
  VAlert,
  VMain,
  VCard,
  VCardTitle,
  VCardText,
  VCardSubtitle,
  VFlex,
  VSheet,
  VSubheader,

  VFooter,
} from 'vuetify/lib'
//import { Ripple } from 'vuetify/lib/directives'
*/
import 'vuetify/dist/vuetify.css';

Vue.use(Vuetify);
import VueI18n from 'vue-i18n'
import pl from 'vuetify/lib/locale/pl';
Vue.use(VueI18n);

const opts = {
  lang: {
    locales: {pl},
    current: 'pl',
  },
}

export default new Vuetify(opts)